module.exports = __webpack_public_path__ + "components/country-flag/static/sn-302cd23a62c88427209143538855d184.svg";